import { useState } from "react";
import ContactForm from "./ContactForm";
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { Grommet } from 'grommet';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';

import theme from "./theme";

import "./FastQuoteFlow.css";
import { FastQuoteComponent } from "../../fast-quote/fast-quote.component";
import { EstimateService } from "../../services/estimates.service";

function counterReducer(state = { context: { accessToken: "" } }, action: any) {
  return state;
}
const store = createStore(counterReducer)

function FastQuoteFlow() {
  const [isContactFormShown, setIsContactFormShown] = useState(false);
  const [paramsObject, setParamsObject] = useState({});

  const [county, setCounty] = useState('');
  const [state, setState] = useState('');

  const [rowCropArea, setRowCropArea] = useState(0);
  const [rowPastureArea, setRowPastureArea] = useState(0);
  const [totalArea, setTotalArea] = useState(0);
  const [potentialPayout, setPotentialPayout] = useState('');
  const flags = useFlags();
  const hidePayout = flags.potentialPayoutAbTesting;
  const hideNitrogenReduction = flags.hideNitrogenReduction;

  const goBack: () => void = () => {
    setIsContactFormShown(false);
  };


  const nextStep = async (locations: any) => {
    setIsContactFormShown(current => !current);
    let rowCropArea = 0;
    let pastureLandArea = 0;
    let totalArea = 0;
    for (const location of locations) {
      setCounty(location.county);
      setState(location.state);

      if (location.rowCropArea) {
        rowCropArea += location.rowCropArea;
      }
      if (location.pastureLandArea) {
        pastureLandArea += location.pastureLandArea;
      }

      if (location.rowCropArea && location.rowCropArea > location.pastureLandArea) {
        totalArea += location.rowCropArea;
      } else if (location.pastureLandArea) {
        totalArea += location.pastureLandArea;
      }
    }
    setRowCropArea(rowCropArea);
    setRowPastureArea(pastureLandArea);
    setTotalArea(totalArea);

    // todo call API to calculate results

    const calculationResult: any = await EstimateService.calculateResult(locations, hideNitrogenReduction);
    setParamsObject({
      scenarios: calculationResult.scenarios
    });
    setPotentialPayout(calculationResult.result.calculatorResultA?.optionA?.total || 0);

    let top = 0;
    const rootElement = document.querySelector('#root');
    if (rootElement) {
      top = rootElement.getBoundingClientRect().top + window.scrollY - 140;
    }
    window.scrollTo({
      top: top,
      left: 0,
      behavior: 'smooth'
    });

    window.dataLayer?.push({ 'event': 'Calculator Next Step' });
  };

  return (
    <Grommet theme={theme}>
      <div className="FastQuoteFlow">
        <Provider store={store}>
          <div className="FastQuoteFlow__QuotePageContainer" style={{ display: !isContactFormShown ? 'block' : 'none' }}>
            <FastQuoteComponent actionButton={nextStep} />
          </div>

          <div style={{ display: isContactFormShown ? 'block' : 'none' }}>
            {/* show the ContactForm component on next button click */}
            {
              isContactFormShown && <ContactForm allQuoteParams={
                {
                  params: paramsObject,
                  hidePayout: hidePayout,
                  countyParam: county,
                  stateParam: state,
                  rowCropAreaParam: rowCropArea,
                  rowPastureAreaParam: rowPastureArea,
                  totalAreaParam: totalArea,
                  potentialPayoutParam: potentialPayout,
                }
              } backButton={goBack} />
            }
          </div>

        </Provider>
      </div>
    </Grommet>
  );
}

export default FastQuoteFlow;
